<template>
  <div class="dbs_pr-container c-product-desc" id="productRatings">
    <div class="c-product-desc__head" @click="mobileToggle()">
      <h2 class="t-head t-head--ico t-head--middle u-paint-green-1">
        <strong>Opinie <span class="reviews-count">{{reviewsCount}}</span></strong>
      </h2>
      <span class="c-product-desc__trigger" v-bind:class="{ active: mobileopen }">
        <span class="o-ico o-ico--arrow-down o-ico--s">
          <svg> <use xlink:href="#ico-down-open" aria-hidden="true"></use> </svg>
        </span>
      </span>
    </div>
    <div class="l-opinions" v-bind:class="{ active: mobileopen }">
      <div class="t-group u-text-center">
        <h2 class="t-head t-head--default t-head--bold">
          Opinie klientów o: <template v-if="product.name">{{ product.name }}</template><template v-if="product.manufacturer">, {{ product.manufacturer }}</template>
        </h2>
      </div>

      <LoadingIndicator :isLoading="isLoading" loadingText="Ładowanie opinii...">
        <template v-if="hasReviews()">
          <ReviewsSummary :ratings="ratings" @addReviewClicked="addReview"/>

          <section class="c-opinions-list">
            <template v-for="review in getReviewsForCurrentPage()">
              <Review :review="review" :productName="product.name" :key="review.id" />
            </template>
          </section>

          <div class="c-actions-list u-justify-content-center" v-if="showAction()">
            <div class="c-actions-list__item">
              <button type="button" class="c-btn c-btn--default c-btn--theme-7 u-text-uppercase c-btn--border-radius-full" @click="getMoreReviews()">
                <span class="c-btn__wrap">
                    <span class="c-btn__label">+ Pokaż kolejne opinie</span>
                </span>
              </button>
            </div>
          </div>
        </template>
        <template v-else-if="errorOccurred">
          <div class="c-message c-message--default">
            <p>
              <strong>Wystąpił problem podczas ładowania opinii.</strong>
            </p>
          </div>
        </template>
        <template v-else>
          <div class="c-message c-message--default">
            <p>
              <strong>Ten produkt nie ma jeszcze żadnych ocen. Dodaj pierwszą!</strong>
              <span v-if="!isLoading && reviewsCount > 0" class="c-btn c-btn--default c-btn--green u-text-uppercase"><template> {{reviewsCount}} ocen</template></span>
              <a @click="addReview" class="c-btn c-btn--secondly c-btn--theme-6 u-text-uppercase f_right l-opinions__btn c-btn--border-radius-full">
                <span class="c-btn__wrap">
                  <span class="c-btn__label">Dodaj opinię</span>
                </span>
              </a>
            </p>
          </div>
        </template>
      </LoadingIndicator>
    </div>
  </div>
</template>
<script>

import Review from './Review.vue'
import ReviewsSummary from './ReviewsSummary.vue'
import LoadingIndicator from '@/components/LoadingIndicator.vue'
import {getProductReviews} from '@/api/productReviews'
import {EventBus, GlobalEvents, logError, roundFloatNumberToOnePlace, calculateAverage, breakpointsMatches} from '@/shared'

export default {
  props: ['product'],

  components: {
    Review,
    ReviewsSummary,
    LoadingIndicator
  },

  data () {
    return {
      reviews: [],
      reviewsCount: 0,
      currentReviews: 0,
      currentPage: 0,
      pageSize: breakpointsMatches.mobileSmall.matches ? 1 : 3,
      isLoading: false,
      errorOccurred: false,
      isFirstLoaded: true,
      mobileopen: false
    }
  },

  mounted () {
    const self = this

    this.isLoading = true
    getProductReviews(this.product.id)
      .then(reviewsData => {
        const reviews = reviewsData.reviews
        self.reviewsCount = reviews.length
        self.reviews = reviews
        self.isLoading = false
        self.errorOccurred = false
        if (document.querySelector('#product-count-reviews') && reviews.length > 0) {
          document.querySelector('#product-count-reviews').innerHTML = reviews.length
          document.querySelector('#product-count-reviews').classList.add('open')
        }
        self.$emit('reviews:loaded', reviewsData)
      })
      .catch(error => {
        logError(error)
        self.isLoading = false
        self.errorOccurred = true
      })
  },

  computed: {
    ratings () {
      return this.reviews.map(review => review.rating)
    },

    averageRating () {
      const averageRating = calculateAverage(this.ratings)
      return roundFloatNumberToOnePlace(averageRating)
    }
  },

  methods: {
    mobileToggle () {
      this.mobileopen = !this.mobileopen
    },
    hasReviews () {
      return this.reviewsCount > 0
    },

    hasMoreThanOnePage () {
      return this.reviewsCount > this.pageSize
    },

    isLast () {
      return this.currentReviews >= this.reviewsCount
    },

    getMoreReviews () {
      this.isFirstLoaded = false
      this.increasePage()
    },

    showAction () {
      return !this.isLast() && this.hasMoreThanOnePage()
    },

    getReviewsForCurrentPage () {
      if (this.isFirstLoaded) {
        this.currentReviews = this.pageSize
      } else {
        this.currentReviews = this.currentPage
      }

      return this.reviews.slice(0, this.currentReviews)
    },

    increasePage () {
      this.currentPage = this.currentPage + 10
    },

    addReview () {
      const product = {...this.product, averageRating: this.averageRating, reviewsCount: this.reviews.length}

      EventBus.$emit(GlobalEvents.reviews_showAddReviewForm, {product: product})
    }
  }
}
</script>
<style lang="scss">
.count-reviews {
  opacity: 0.5;
  font-size: 14px;
  display: inline-block;
  vertical-align: top;
  margin-left: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/ProductPage/ReviewsList.vue